import React from 'react'
import './TicketItem.scss'

const getTime = (time, duration) => {
    const getHours = `${time.getHours()}`
    const getMinutes = `${time.getMinutes()}`
    const arrTime = Number(getHours) * 60 + Number(getMinutes)
    const allTime = arrTime + duration
    const haveZero = (num) => {
        return num < 10 ? `0${num}` : `${num}`
    }
    const checkHour = (hour) => {
        return hour >= 24 ? `${hour - 24}` : `${hour}`
    }
    const destTimeHour = `${Math.floor(allTime / 60)}`
    const desTimeMin = `${allTime % destTimeHour}`
    return (`${haveZero(checkHour(getHours))}:${haveZero(checkHour(getMinutes))}-${haveZero(checkHour(destTimeHour))}:${haveZero(checkHour(desTimeMin))}`)
}

const getHoursFromDuration = (time) => {
    const getHours = `${Math.floor(time / 60)}`
    const getMinutes = `${time % getHours}`
    const haveZero = (num) => num < 10 ? `0${num}` : `${num}`
    return (`${haveZero(getHours)}ч ${haveZero(getMinutes)}м`)

}

const numberWithSpaces = (num) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

const stopsNaming = (num) => {
    switch (num.length) {
        case 0:
            return 'Без остановок'
        case 1:
            return '1 остановка'
        case 2:
            return '2 остановки'
        case 3:
            return '3 остановки'
        default:
            return 'Без остановок'
    }
}

const TicketItem = ({ price, carrier, segments }) => {

    return (
        <div className='ticket'>
            <div className='ticket__header'>
                <div className='ticket__price'>
                    {numberWithSpaces(price)} Р
                </div>
                <img src={`https://pics.avs.io/99/36/${carrier}.png`} alt='carrier' />
            </div>
            <div className='ticket__body'>
                {
                    segments.map((item) => {
                        const data = new Date(item.date)
                        return (
                            <div key={item.date} className='ticket-segment'>
                                <div className='ticket-segment-route'>
                                    <div className='ticket-segment-route-title second'>{item.origin}-{item.destination}</div>
                                    <div className='ticket-segment-route-time primary'>{getTime(data, item.duration)}</div>
                                </div>
                                <div className='ticket-segment-duration second' > В пути <span className='ticket-segment-duration-time primary'>{getHoursFromDuration(item.duration)}</span></div>
                                <div className='ticket-segment-stops'>
                                    <div className='ticket-segment-stops-num second'>{stopsNaming(item.stops)} </div>
                                    <span className='ticket-segment-stops-array primary'>{item.stops.join(', ')}</span>
                                </div>
                            </div>
                        )
                    })
                }
            </div>

        </div>
    )
}

export default TicketItem
